import { Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import { FunctionComponent } from 'react'
import gaiaTheme from '../../../root-components/theme'
import { usePdfExportMode } from '../../../hooks/use-pdf-export-mode'
import { GraphDonutChart } from '../../../components/presentation-components/analytics-components/graphs/graph-donut-chart'
import {
  getGaiaReportSectionShellSx,
  getGaiaReportBodyTextSx,
} from '../../public-reports/components/gaia-report-web-page-pdf-styles'
import type { IColorPalatte } from '../shared-services/project-reports.model'
import { useReportContentOverride } from '../../public-reports/shared-services/gaia-report-content'

function normalisePieData(raw: any): { label: string; value: number }[] {
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  return raw.breakdown ?? raw.locationBased ?? raw.marketBased ?? []
}

export const ProjectReportWebPageEmissions: FunctionComponent<{
  colorPalatte: IColorPalatte
  scopePieData: any
  projectLabel: string
}> = ({ colorPalatte, scopePieData, projectLabel }) => {
  const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'))
  const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'))
  const pdfExport = usePdfExportMode()

  const pieItems = normalisePieData(scopePieData)

  const heading = useReportContentOverride('emissionsByScope.heading')
  const body = useReportContentOverride('emissionsByScope.body')

  return (
    <Stack sx={getGaiaReportSectionShellSx({ backgroundColor: colorPalatte.veryDark, pdfExport })}>
      <Typography variant={isMobileModeSm ? 'h5' : 'h4'} sx={{ color: 'white', fontWeight: 700, mb: 2 }}>
        {heading ?? 'Emissions by Scope'}
      </Typography>
      <Typography sx={{ ...getGaiaReportBodyTextSx({ color: 'rgba(255,255,255,0.8)', isMobileModeMd, isMobileModeSm, pdfExport }), mb: 2 }}>
        {body ?? `Breakdown of this ${projectLabel.toLowerCase()}'s emissions across Scope 1 (direct), Scope 2 (purchased energy) and Scope 3 (value chain).`}
      </Typography>
      <Grid container spacing={2} justifyContent='center'>
        <Grid item xs={12} md={8} lg={6}>
          <div className='chart-block'>
            <GraphDonutChart
              title='Emissions by Scope'
              dataset={pieItems.map(d => ({ label: d.label, value: d.value }))}
              colors={colorPalatte.chartSeries ?? [colorPalatte.main, colorPalatte.light, colorPalatte.veryLight]}
              backgroundColor='transparent'
              textColor='white'
              chartHeight={pdfExport ? 220 : 325}
              titleVariant={pdfExport ? 'body2' : 'subtitle1'}
            />
          </div>
        </Grid>
      </Grid>
    </Stack>
  )
}
